import React, { useRef, useLayoutEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IBdsSegment } from '../../../interfaces/bdsSegment';
import './BdsSegment.scss';

const BdsSegment = ({ items, action, activeIndex, fullWidth = false, type = 'primary', size = 'lg' }: IBdsSegment) => {
  const { t } = useTranslation();
  const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, left: 0 });
  const [isMounted, setIsMounted] = useState(false);
  const tabsRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (tabsRef.current) {
      const activeTab = tabsRef.current.children[activeIndex] as HTMLElement;
      if (activeTab) {
        setIndicatorStyle({
          width: activeTab.offsetWidth,
          left: activeTab.offsetLeft
        });
      }
    }

    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 0);

    return () => clearTimeout(timer);
  }, [activeIndex]);

  const handleKeyDown = (index: number) => (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      action(index);
    }
  };

  return (
    <div className={`bds-segment ${fullWidth ? 'full-width' : ''} ${type}`} ref={tabsRef}>
      {items.map((item, index) => (
        <button
          key={`segment-item-${item}-${index}`}
          className={`segment-item ${activeIndex === index ? 'active ' + type : ''} ${size}`}
          onClick={() => action(index)}
          tabIndex={0}
          onKeyDown={handleKeyDown(index)}
        >
          <span className="segment-item-text whitespace-nowrap">{t(item)}</span>
        </button>
      ))}
      <div
        className={`indicator ${type} ${size}`}
        style={{
          ...indicatorStyle,
          transition: isMounted ? 'width 0.3s ease-in-out, left 0.3s ease-in-out' : 'none'
        }}
      />
    </div>
  );
};

export default BdsSegment;
